import { getCopies } from '../redux/api/settings-api'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { useSearchParams } from 'react-router'
import { useEcommerceId } from './use-ecommerce-id'

export function useEcommerceCopies() {
  const dispatch = useAppDispatch()

  const [searchParams] = useSearchParams()

  const ecommerceId = searchParams.get('ecommerce_id')

  // The group view picks no store: fall back to its first one, as useSettings does, so reason
  // labels and other copies are not blank.
  const fallbackEcommerceId = useEcommerceId()

  const selectedEcommerce =
    useAppSelector((store) => store.generalData.selectedEcommerce) ??
    ecommerceId ??
    fallbackEcommerceId

  const copiesCall = useAppSelector((store) => store.settingsApi.copies)
  const loadingEcommerceCopies = copiesCall.loading
  const errorEcommerceCopies = copiesCall.error
  const ecommerceCopies = copiesCall.response

  useEffect(() => {
    if (!selectedEcommerce) return
    dispatch(getCopies(selectedEcommerce))
  }, [selectedEcommerce])

  return {
    loadingEcommerceCopies,
    errorEcommerceCopies,
    ecommerceCopies
  }
}
